import { Union, Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { tuple_type, option_type, uint8_type, record_type, int32_type, class_type, union_type, list_type, unit_type, bool_type, lambda_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { ContractTypeValuationSettingResponse, ContractValuationSettingResponse, ContractValuationSetting, ContractTypeValuationSettingResponse$reflection, ValidateContractsDTO, ContractValuationSettingResponse$reflection, ContractTypeMortgage, SelectedContractTypeMortgage, ContractTypeMortgage$reflection } from "./Model.js";
import { Result_Bind, FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { getMaterialIcon, dotsLoading, getStatusBall, Color } from "../../ViewUtils.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import * as react from "react";
import { GlobalDependencies$reflection, getTranslationFrom, SaveStatus as SaveStatus_2, LoadState$2 } from "../../Global.js";
import { toString, fromParts } from "../../fable_modules/fable-library.3.7.20/Decimal.js";
import { ofArrayWithTail, mapIndexed, isEmpty, sortBy, empty, foldBack, choose, singleton as singleton_1, ofArray, cons, map, tryFind } from "../../fable_modules/fable-library.3.7.20/List.js";
import { parseByte, optToStr, stripHtmlTags, String_replace, parseDecimal, stackClasses, delayAsync, parseInt$, logei } from "../../Utils.js";
import { parallel, startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { info, error } from "../../Components/Message/Message.js";
import { arrayHash, equalArrays, compareArrays, int16ToString, uncurry, equals, int32ToString } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { toFail, endsWith, printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { RadioInput, RadioInput_get_getDefault, inputRadio, CheckboxInput, CheckboxInput_get_getDefault, inputCheckbox, SelectOption, ValueProp, SelectOption_get_getDefault, selectOption } from "../../Components/FormFields/FormFields.js";
import { map as map_1, defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { Browser_Types_Event__Event_get_Checked, Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { modalMain, defaultProps, modalCancel, ButtonProps, ButtonProps_get_getDefault, ButtonKind, wrappedButton } from "../../Components/Button/Button.js";
import { HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { SwitchProps, SwitchProps_get_GetDefault, render as render_1 } from "../../Components/Switch/Switch.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { TextProps$1, TextProps$1_GetDefault, render as render_2 } from "../../Components/StatefulFormFields/Text.js";
import { primary } from "../../Components/Panel/Panel.js";
import { MessageType, renderAsModal } from "../../Components/Modals/InfoMessage/InfoMessage.js";
import { useDispatch, useSelector } from "../../Redux/Store.js";
import { render as render_3 } from "../../Components/Modals/Standard.js";
import { getModalContainer, modal, getModalFooterContainer, getModalBodyContainer, getModalHeader, ModalSize } from "../../Components/Modal/Modal.js";
import { saveContractValuationSetting as saveContractValuationSetting_1, saveContractTypeMortgage as saveContractTypeMortgage_1, deleteContractTypeMortgage as deleteContractTypeMortgage_1, loadContractTypeValuationSetting as loadContractTypeValuationSetting_1, loadContractValuationSetting as loadContractValuationSetting_1, loadContractTypeMortgage as loadContractTypeMortgage_1, saveValidateContracts, updateContractTypeValuation, deleteContractValuation, queueContractReEvaluation as queueContractReEvaluation_1, saveContractTypeValuationSetting, updateContractTypeMortgageId } from "./Api.js";
import { append, singleton as singleton_2, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { renderAsModalThenSaveState } from "../../Components/Modals/SaveState/SaveState.js";
import { warning } from "../../Redux/Reducers/ModalsReducer.js";
import { renderDotMenuAreaTable } from "../../Components/Table/Table.js";
import { List_distinct } from "../../fable_modules/fable-library.3.7.20/Seq2.js";
import "../../../src/Containers/MortgageSettings/View.scss";


class ContractTypeMortgageSectionProps extends Record {
    constructor(GetTranslation, IsAdmin, LoadContractTypeMortgagesFn, DeleteContractTypeMortgageFn, SaveContractTypeMortgageFn) {
        super();
        this.GetTranslation = GetTranslation;
        this.IsAdmin = IsAdmin;
        this.LoadContractTypeMortgagesFn = LoadContractTypeMortgagesFn;
        this.DeleteContractTypeMortgageFn = DeleteContractTypeMortgageFn;
        this.SaveContractTypeMortgageFn = SaveContractTypeMortgageFn;
    }
}

function ContractTypeMortgageSectionProps$reflection() {
    return record_type("Containers.MortgageSettings.View.ContractTypeMortgageSectionProps", [], ContractTypeMortgageSectionProps, () => [["GetTranslation", lambda_type(string_type, string_type)], ["IsAdmin", bool_type], ["LoadContractTypeMortgagesFn", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(ContractTypeMortgage$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(ContractTypeMortgage$reflection())]], [["ErrorValue", string_type]]])]))], ["DeleteContractTypeMortgageFn", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [int32_type, string_type], FSharpResult$2, () => [[["ResultValue", int32_type]], [["ErrorValue", string_type]]])]))], ["SaveContractTypeMortgageFn", lambda_type(ContractTypeMortgage$reflection(), lambda_type(bool_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [int32_type, string_type], FSharpResult$2, () => [[["ResultValue", int32_type]], [["ErrorValue", string_type]]])])))]]);
}

function renderStatusBallHtml(getTranslation, isActive) {
    const patternInput = isActive ? [new Color(0), getTranslation("Common.Active")] : [new Color(2), getTranslation("Common.Inactive")];
    return getStatusBall(patternInput[0], patternInput[1]);
}

const renderContractTypeMortgageSection = FunctionComponent_Of_Z5A158BBF((props) => {
    let inputRecord, inputRecord_1, inputRecord_2, inputRecord_7, inputRecord_9, inputRecord_11, inputRecord_13, inputRecord_15, inputRecord_17, children_14, props_13, inputRecord_19, Disabled_2, children_26, children_18, children_20, children_24, children_32;
    const contractTypeMortgagesState = react.useState(new LoadState$2(0));
    const selectedContractTypeMortgageState = react.useState(new SelectedContractTypeMortgage(2));
    const deleteSaveStatusState = react.useState(new SaveStatus_2(0));
    const saveStatusState = react.useState(new SaveStatus_2(0));
    const initSelectedValues = new ContractTypeMortgage(0, "", false, false, 0, fromParts(0, 0, 0, false, 1), fromParts(0, 0, 0, false, 1), 0, 0, false);
    const selectedValuesState = react.useState(initSelectedValues);
    react.useEffect(() => {
        const matchValue = contractTypeMortgagesState[0];
        if (matchValue.tag === 2) {
            const matchValue_1 = selectedContractTypeMortgageState[0];
            switch (matchValue_1.tag) {
                case 1: {
                    selectedValuesState[1](initSelectedValues);
                    break;
                }
                case 0: {
                    const contractTypeMortgageOpt = tryFind((c) => (c.ContractTypeMortgageId === matchValue_1.fields[0]), matchValue.fields[0]);
                    if (contractTypeMortgageOpt == null) {
                        logei("[SelectContractTypeMortgage] Can\u0027t find id.");
                    }
                    else {
                        const contractTypeMortgage = contractTypeMortgageOpt;
                        selectedValuesState[1](contractTypeMortgage);
                    }
                    break;
                }
                default: {
                    selectedValuesState[1](initSelectedValues);
                }
            }
        }
    }, [selectedContractTypeMortgageState[0]]);
    const loadContractTypeMortgage = () => {
        contractTypeMortgagesState[1](new LoadState$2(1));
        startImmediate(singleton.Delay(() => singleton.Bind(props.LoadContractTypeMortgagesFn(), (_arg) => {
            const result = _arg;
            const arg_1 = (result.tag === 1) ? (new LoadState$2(3, result.fields[0])) : (new LoadState$2(2, result.fields[0]));
            contractTypeMortgagesState[1](arg_1);
            return singleton.Zero();
        })));
    };
    react.useEffect(() => {
        loadContractTypeMortgage();
    }, []);
    const matchValue_4 = contractTypeMortgagesState[0];
    switch (matchValue_4.tag) {
        case 1: {
            return dotsLoading;
        }
        case 3: {
            return error(matchValue_4.fields[0].split(""));
        }
        case 2: {
            let selectableContractTypeMortgage;
            const selectables = map((c_1) => [int32ToString(c_1.ContractTypeMortgageId), toText(printf("(%i) %s"))(c_1.ContractTypeMortgageId)(c_1.Name)], matchValue_4.fields[0]);
            selectableContractTypeMortgage = cons(["", props.GetTranslation("Common.Choose")], selectables);
            let ctmSelectHtml;
            let value;
            const matchValue_5 = selectedContractTypeMortgageState[0];
            switch (matchValue_5.tag) {
                case 1: {
                    value = "";
                    break;
                }
                case 0: {
                    value = int32ToString(matchValue_5.fields[0]);
                    break;
                }
                default: {
                    value = "";
                }
            }
            const children_1 = [selectOption((inputRecord = SelectOption_get_getDefault(), new SelectOption(new ValueProp(0, value, (e) => {
                const arg_8 = defaultArg(map_1((arg_7) => (new SelectedContractTypeMortgage(0, arg_7)), parseInt$(Browser_Types_Event__Event_get_Value(e))), new SelectedContractTypeMortgage(2));
                selectedContractTypeMortgageState[1](arg_8);
            }), "select-contract-type-mortgage", selectableContractTypeMortgage, inputRecord.Classes, inputRecord.LabelText, inputRecord.Disabled, inputRecord.HTMLProps)))];
            ctmSelectHtml = react.createElement("div", {
                className: "left__select",
            }, ...children_1);
            const createNewButtonHtml = wrappedButton(new ButtonKind(0), (inputRecord_1 = ButtonProps_get_getDefault(), new ButtonProps(props.GetTranslation("Common.CreateNew"), inputRecord_1.Content, (_arg_3) => {
                selectedContractTypeMortgageState[1](new SelectedContractTypeMortgage(1));
            }, !props.IsAdmin, "create-new-contract-type-mortgage-btn", inputRecord_1.SaveStatus, inputRecord_1.HTMLProps, inputRecord_1.ExtraClasses, inputRecord_1.Icon)));
            let isDisabled;
            const matchValue_6 = selectedContractTypeMortgageState[0];
            switch (matchValue_6.tag) {
                case 1: {
                    isDisabled = false;
                    break;
                }
                case 2: {
                    isDisabled = true;
                    break;
                }
                default: {
                    isDisabled = false;
                }
            }
            let deleteButtonHtml;
            let errorMessageHtml;
            const matchValue_7 = deleteSaveStatusState[0];
            errorMessageHtml = ((matchValue_7.tag === 3) ? error(matchValue_7.fields[0].split("")) : react.createElement(react.Fragment, {}));
            const children_4 = [wrappedButton(new ButtonKind(0), (inputRecord_2 = ButtonProps_get_getDefault(), new ButtonProps(props.GetTranslation("Common.Remove"), inputRecord_2.Content, (_arg_4) => {
                let a;
                startImmediate((a = singleton.Delay(() => {
                    let matchValue_2;
                    return singleton.Combine((matchValue_2 = (selectedContractTypeMortgageState[0]), (matchValue_2.tag === 2) ? ((singleton.Zero())) : ((matchValue_2.tag === 0) ? ((deleteSaveStatusState[1](new SaveStatus_2(1)), singleton.Bind(props.DeleteContractTypeMortgageFn(matchValue_2.fields[0]), (_arg_1) => {
                        const result_1 = _arg_1;
                        const arg_3 = (result_1.tag === 1) ? (new SaveStatus_2(3, result_1.fields[0])) : (new SaveStatus_2(2));
                        deleteSaveStatusState[1](arg_3);
                        return singleton.Zero();
                    }))) : ((singleton.Zero())))), singleton.Delay(() => singleton.Return("Must return something other than unit")));
                }), singleton.Delay(() => singleton.Bind(a, (_arg_6) => singleton.Return((startImmediate(delayAsync(5000, () => {
                    deleteSaveStatusState[1](new SaveStatus_2(0));
                })), (selectedContractTypeMortgageState[1](new SelectedContractTypeMortgage(2)), loadContractTypeMortgage())))))));
            }, (!props.IsAdmin) ? true : isDisabled, "delete-contract-type-mortgage-btn", deleteSaveStatusState[0], inputRecord_2.HTMLProps, inputRecord_2.ExtraClasses, inputRecord_2.Icon))), errorMessageHtml];
            deleteButtonHtml = react.createElement("div", {}, ...children_4);
            let selectedValuesHtml;
            let switchesHtml;
            const renderSwitch = (id_3, isChecked, label, onChange) => {
                let inputRecord_3;
                const props_9 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "align-items-center", "justify-content-between", "right__switch"])))];
                const children_8 = [react.createElement("div", {
                    className: "mr-4",
                }, label), render_1((inputRecord_3 = SwitchProps_get_GetDefault(), new SwitchProps(id_3, isChecked, (arg_13) => {
                    const arg_12 = onChange(arg_13);
                    selectedValuesState[1](arg_12);
                }, isDisabled)))];
                return react.createElement("div", keyValueList(props_9, 1), ...children_8);
            };
            const children_10 = [renderSwitch("require-credit-check-switch", (selectedValuesState[0]).RequireCreditCheck, "RequireCreditCheck", (e_1) => {
                const inputRecord_4 = selectedValuesState[0];
                return new ContractTypeMortgage(inputRecord_4.ContractTypeMortgageId, inputRecord_4.Name, Browser_Types_Event__Event_get_Checked(e_1), inputRecord_4.TrafficIsAlternativeToPayedInvoices, inputRecord_4.RequiredNumberOfPayedInvoices, inputRecord_4.FeeMin, inputRecord_4.FeeMax, inputRecord_4.AgeMin, inputRecord_4.AgeMax, inputRecord_4.RequirePhysicalContract);
            }), renderSwitch("traffic-is-alternative-switch", (selectedValuesState[0]).TrafficIsAlternativeToPayedInvoices, "TrafficIsAlternativeToPayedInvoices", (e_2) => {
                const inputRecord_5 = selectedValuesState[0];
                return new ContractTypeMortgage(inputRecord_5.ContractTypeMortgageId, inputRecord_5.Name, inputRecord_5.RequireCreditCheck, Browser_Types_Event__Event_get_Checked(e_2), inputRecord_5.RequiredNumberOfPayedInvoices, inputRecord_5.FeeMin, inputRecord_5.FeeMax, inputRecord_5.AgeMin, inputRecord_5.AgeMax, inputRecord_5.RequirePhysicalContract);
            }), renderSwitch("require-physical-contract-switch", (selectedValuesState[0]).RequirePhysicalContract, "RequirePhysicalContract", (e_3) => {
                const inputRecord_6 = selectedValuesState[0];
                return new ContractTypeMortgage(inputRecord_6.ContractTypeMortgageId, inputRecord_6.Name, inputRecord_6.RequireCreditCheck, inputRecord_6.TrafficIsAlternativeToPayedInvoices, inputRecord_6.RequiredNumberOfPayedInvoices, inputRecord_6.FeeMin, inputRecord_6.FeeMax, inputRecord_6.AgeMin, inputRecord_6.AgeMax, Browser_Types_Event__Event_get_Checked(e_3));
            })];
            switchesHtml = react.createElement("div", {}, ...children_10);
            const requiredNumberPayedInvoicesHtml = render_2()((inputRecord_7 = TextProps$1_GetDefault(), new TextProps$1(int32ToString((selectedValuesState[0]).RequiredNumberOfPayedInvoices), inputRecord_7.Type, inputRecord_7.Classes, (e_4) => {
                const arg_14 = defaultArg(map_1((value_2) => {
                    const inputRecord_8 = selectedValuesState[0];
                    return new ContractTypeMortgage(inputRecord_8.ContractTypeMortgageId, inputRecord_8.Name, inputRecord_8.RequireCreditCheck, inputRecord_8.TrafficIsAlternativeToPayedInvoices, value_2, inputRecord_8.FeeMin, inputRecord_8.FeeMax, inputRecord_8.AgeMin, inputRecord_8.AgeMax, inputRecord_8.RequirePhysicalContract);
                }, parseInt$(Browser_Types_Event__Event_get_Value(e_4))), selectedValuesState[0]);
                selectedValuesState[1](arg_14);
            }, isDisabled, "RequiredNumberOfPayedInvoices", "required-number-payed-invoices", inputRecord_7.ValidationFn, inputRecord_7.DynamicWidth, inputRecord_7.HTMLProps, inputRecord_7.OnBlur, inputRecord_7.OnFocus, inputRecord_7.AutoComplete, inputRecord_7.Name)));
            const feeMinHtml = render_2()((inputRecord_9 = TextProps$1_GetDefault(), new TextProps$1(toString((selectedValuesState[0]).FeeMin), inputRecord_9.Type, inputRecord_9.Classes, (e_5) => {
                let str_1;
                const arg_15 = defaultArg(map_1((value_5) => {
                    const inputRecord_10 = selectedValuesState[0];
                    return new ContractTypeMortgage(inputRecord_10.ContractTypeMortgageId, inputRecord_10.Name, inputRecord_10.RequireCreditCheck, inputRecord_10.TrafficIsAlternativeToPayedInvoices, inputRecord_10.RequiredNumberOfPayedInvoices, value_5, inputRecord_10.FeeMax, inputRecord_10.AgeMin, inputRecord_10.AgeMax, inputRecord_10.RequirePhysicalContract);
                }, parseDecimal((str_1 = String_replace(",", ".", Browser_Types_Event__Event_get_Value(e_5)), endsWith(str_1, ".") ? (str_1 + "00") : str_1))), selectedValuesState[0]);
                selectedValuesState[1](arg_15);
            }, isDisabled, "FeeMin", "fee-min", inputRecord_9.ValidationFn, inputRecord_9.DynamicWidth, inputRecord_9.HTMLProps, inputRecord_9.OnBlur, inputRecord_9.OnFocus, inputRecord_9.AutoComplete, inputRecord_9.Name)));
            const feeMaxHtml = render_2()((inputRecord_11 = TextProps$1_GetDefault(), new TextProps$1(toString((selectedValuesState[0]).FeeMax), inputRecord_11.Type, inputRecord_11.Classes, (e_6) => {
                let str_3;
                const arg_16 = defaultArg(map_1((value_8) => {
                    const inputRecord_12 = selectedValuesState[0];
                    return new ContractTypeMortgage(inputRecord_12.ContractTypeMortgageId, inputRecord_12.Name, inputRecord_12.RequireCreditCheck, inputRecord_12.TrafficIsAlternativeToPayedInvoices, inputRecord_12.RequiredNumberOfPayedInvoices, inputRecord_12.FeeMin, value_8, inputRecord_12.AgeMin, inputRecord_12.AgeMax, inputRecord_12.RequirePhysicalContract);
                }, parseDecimal((str_3 = String_replace(",", ".", Browser_Types_Event__Event_get_Value(e_6)), endsWith(str_3, ".") ? (str_3 + "00") : str_3))), selectedValuesState[0]);
                selectedValuesState[1](arg_16);
            }, isDisabled, "FeeMax", "fee-max", inputRecord_11.ValidationFn, inputRecord_11.DynamicWidth, inputRecord_11.HTMLProps, inputRecord_11.OnBlur, inputRecord_11.OnFocus, inputRecord_11.AutoComplete, inputRecord_11.Name)));
            const ageMinHtml = render_2()((inputRecord_13 = TextProps$1_GetDefault(), new TextProps$1(int32ToString((selectedValuesState[0]).AgeMin), inputRecord_13.Type, inputRecord_13.Classes, (e_7) => {
                const arg_17 = defaultArg(map_1((value_10) => {
                    const inputRecord_14 = selectedValuesState[0];
                    return new ContractTypeMortgage(inputRecord_14.ContractTypeMortgageId, inputRecord_14.Name, inputRecord_14.RequireCreditCheck, inputRecord_14.TrafficIsAlternativeToPayedInvoices, inputRecord_14.RequiredNumberOfPayedInvoices, inputRecord_14.FeeMin, inputRecord_14.FeeMax, value_10, inputRecord_14.AgeMax, inputRecord_14.RequirePhysicalContract);
                }, parseInt$(Browser_Types_Event__Event_get_Value(e_7))), selectedValuesState[0]);
                selectedValuesState[1](arg_17);
            }, isDisabled, "AgeMin", "age-min", inputRecord_13.ValidationFn, inputRecord_13.DynamicWidth, inputRecord_13.HTMLProps, inputRecord_13.OnBlur, inputRecord_13.OnFocus, inputRecord_13.AutoComplete, inputRecord_13.Name)));
            const ageMaxHtml = render_2()((inputRecord_15 = TextProps$1_GetDefault(), new TextProps$1(int32ToString((selectedValuesState[0]).AgeMax), inputRecord_15.Type, inputRecord_15.Classes, (e_8) => {
                const arg_18 = defaultArg(map_1((value_12) => {
                    const inputRecord_16 = selectedValuesState[0];
                    return new ContractTypeMortgage(inputRecord_16.ContractTypeMortgageId, inputRecord_16.Name, inputRecord_16.RequireCreditCheck, inputRecord_16.TrafficIsAlternativeToPayedInvoices, inputRecord_16.RequiredNumberOfPayedInvoices, inputRecord_16.FeeMin, inputRecord_16.FeeMax, inputRecord_16.AgeMin, value_12, inputRecord_16.RequirePhysicalContract);
                }, parseInt$(Browser_Types_Event__Event_get_Value(e_8))), selectedValuesState[0]);
                selectedValuesState[1](arg_18);
            }, isDisabled, "AgeMax", "age-max", inputRecord_15.ValidationFn, inputRecord_15.DynamicWidth, inputRecord_15.HTMLProps, inputRecord_15.OnBlur, inputRecord_15.OnFocus, inputRecord_15.AutoComplete, inputRecord_15.Name)));
            const nameHtml = render_2()((inputRecord_17 = TextProps$1_GetDefault(), new TextProps$1((selectedValuesState[0]).Name, inputRecord_17.Type, inputRecord_17.Classes, (e_9) => {
                let arg_19;
                const value_14 = Browser_Types_Event__Event_get_Value(e_9);
                const inputRecord_18 = selectedValuesState[0];
                arg_19 = (new ContractTypeMortgage(inputRecord_18.ContractTypeMortgageId, value_14, inputRecord_18.RequireCreditCheck, inputRecord_18.TrafficIsAlternativeToPayedInvoices, inputRecord_18.RequiredNumberOfPayedInvoices, inputRecord_18.FeeMin, inputRecord_18.FeeMax, inputRecord_18.AgeMin, inputRecord_18.AgeMax, inputRecord_18.RequirePhysicalContract));
                selectedValuesState[1](arg_19);
            }, isDisabled, "Name", "name-input", inputRecord_17.ValidationFn, inputRecord_17.DynamicWidth, inputRecord_17.HTMLProps, inputRecord_17.OnBlur, inputRecord_17.OnFocus, inputRecord_17.AutoComplete, inputRecord_17.Name)));
            const children_16 = [switchesHtml, (children_14 = [(props_13 = [new HTMLAttr(65, stackClasses(ofArray(["mortgage-settings__container-horizontal", "flex-wrap"])))], react.createElement("div", keyValueList(props_13, 1), nameHtml, requiredNumberPayedInvoicesHtml, feeMinHtml, feeMaxHtml, ageMinHtml, ageMaxHtml))], react.createElement("div", {}, ...children_14))];
            selectedValuesHtml = react.createElement("div", {
                className: "mortgage-settings__container-horizontal",
            }, ...children_16);
            const saveButtonHtml = wrappedButton(new ButtonKind(0), (inputRecord_19 = ButtonProps_get_getDefault(), (Disabled_2 = ((isDisabled ? true : equals(saveStatusState[0], new SaveStatus_2(2))) ? true : (!props.IsAdmin)), new ButtonProps(equals(saveStatusState[0], new SaveStatus_2(2)) ? props.GetTranslation("Common.Saved") : props.GetTranslation("Common.Save"), inputRecord_19.Content, (_arg_7) => {
                let a_2, dto, isNew, matchValue_3;
                const matchValue_8 = selectedContractTypeMortgageState[0];
                switch (matchValue_8.tag) {
                    case 1:
                    case 0: {
                        startImmediate((a_2 = ((dto = (selectedValuesState[0]), (saveStatusState[1](new SaveStatus_2(1)), (isNew = ((matchValue_3 = (selectedContractTypeMortgageState[0]), (matchValue_3.tag === 0) ? false : (matchValue_3.tag === 1))), singleton.Delay(() => singleton.Bind(props.SaveContractTypeMortgageFn(dto, isNew), (_arg_2) => {
                            const result_2 = _arg_2;
                            const arg_4 = (result_2.tag === 1) ? (new SaveStatus_2(3, result_2.fields[0])) : (new SaveStatus_2(2));
                            saveStatusState[1](arg_4);
                            return singleton.Return("Something other than unit");
                        })))))), singleton.Delay(() => singleton.Bind(a_2, (_arg_9) => singleton.Return((startImmediate(delayAsync(5000, () => {
                            saveStatusState[1](new SaveStatus_2(0));
                        })), loadContractTypeMortgage()))))));
                        break;
                    }
                    default: {
                    }
                }
            }, Disabled_2, "save-btn", saveStatusState[0], inputRecord_19.HTMLProps, inputRecord_19.ExtraClasses, inputRecord_19.Icon))));
            const children_34 = [(children_26 = [(children_18 = [props.GetTranslation("Contracts.MortgageSettings.MortgageTerms")], react.createElement("h5", {
                className: "mb-0",
                ["data-translation"]: "Contracts.MortgageSettings.MortgageTerms",
            }, ...children_18)), (children_20 = [props.GetTranslation("Contracts.MortgageSettings.MortgageTermsDescription")], react.createElement("p", {
                className: "blockquote-footer",
                ["data-translation"]: "Contracts.MortgageSettings.MortgageTermsDescription",
            }, ...children_20)), (children_24 = [ctmSelectHtml, react.createElement("div", {
                className: "mortgage-settings__container-horizontal",
            }, createNewButtonHtml)], react.createElement("div", {
                className: "mortgage-settings__container-vertical",
            }, ...children_24))], react.createElement("div", {}, ...children_26)), (children_32 = [react.createElement("div", {
                className: "contract-type-mortgage__right",
            }, selectedValuesHtml), react.createElement("div", {
                className: "contract-type-mortgage__buttons",
            }, deleteButtonHtml, saveButtonHtml)], react.createElement("div", {
                className: "mortgage-settings__container-vertical",
            }, ...children_32))];
            return react.createElement("div", {
                className: "contract-type-mortgage mortgage-settings__section",
            }, ...children_34);
        }
        default: {
            return react.createElement(react.Fragment, {});
        }
    }
}, "ContractTypeMortgageSection", uncurry(2, void 0), void 0, "renderContractTypeMortgageSection", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\MortgageSettings\\View.fs", 442);

class ContractValuationSettingSectionProps extends Record {
    constructor(GetTranslation, IsAdmin, Response, SaveContractValuationSettingFn) {
        super();
        this.GetTranslation = GetTranslation;
        this.IsAdmin = IsAdmin;
        this.Response = Response;
        this.SaveContractValuationSettingFn = SaveContractValuationSettingFn;
    }
}

function ContractValuationSettingSectionProps$reflection() {
    return record_type("Containers.MortgageSettings.View.ContractValuationSettingSectionProps", [], ContractValuationSettingSectionProps, () => [["GetTranslation", lambda_type(string_type, string_type)], ["IsAdmin", bool_type], ["Response", ContractValuationSettingResponse$reflection()], ["SaveContractValuationSettingFn", lambda_type(bool_type, lambda_type(string_type, lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [int32_type, string_type], FSharpResult$2, () => [[["ResultValue", int32_type]], [["ErrorValue", string_type]]])]))))]]);
}

const renderContractValuationSettingSection = FunctionComponent_Of_Z5A158BBF((props) => {
    let children, renderActionRow, maxBoundMonthsActionsHtml, addBoundMonthsActionsHtml, maxBoundMonthsLabel, arg_10, addBoundMonthsLabel, arg_13, children_18, children_12, inputRecord, children_16, inputRecord_1, children_21, children_35, children_23, children_25, children_29, children_27, children_33, children_31;
    const saveStatusState = react.useState(new SaveStatus_2(0));
    let editPanelHtml;
    const saveContractValuationSetting = (isCreateNew, key, value) => {
        saveStatusState[1](new SaveStatus_2(1));
        return singleton.Delay(() => singleton.Bind(props.SaveContractValuationSettingFn(isCreateNew, key, value), (_arg) => {
            const result = _arg;
            const arg = (result.tag === 1) ? (new SaveStatus_2(3, result.fields[0])) : (new SaveStatus_2(2));
            saveStatusState[1](arg);
            return singleton.Return("Something other than unit");
        }));
    };
    const responseMaxBoundMonthsValue = map_1((s_1) => s_1.Value, tryFind((s) => (s.Key === "MaxBoundMonths"), props.Response.ContractValuationSettings));
    const responseAddBoundMonthsValue = map_1((s_2) => s_2.Value, tryFind((c) => (c.Key === "AddBoundMonths"), props.Response.ContractValuationSettings));
    const isEditingMaxBoundMonthsState = react.useState(false);
    const isEditingAddBoundMonthsState = react.useState(false);
    let maxBoundMonthsState;
    const arg_1 = defaultArg(responseMaxBoundMonthsValue, "36");
    maxBoundMonthsState = react.useState(arg_1);
    let addBoundMonthsState;
    const arg_2 = defaultArg(responseAddBoundMonthsValue, "0");
    addBoundMonthsState = react.useState(arg_2);
    editPanelHtml = primary((children = [props.GetTranslation("Contracts.MortgageSettings.Settings")], react.createElement("span", {
        className: "font-weight-bold",
    }, ...children)), (renderActionRow = ((onSaveClick, updateEditFn, isEditing) => {
        let children_2, children_4;
        if (isEditing) {
            const children_6 = [(children_2 = [getMaterialIcon("save")], react.createElement("span", {
                className: "panel-row__edit",
                onClick: (arg_4) => {
                    onSaveClick(arg_4);
                },
            }, ...children_2)), (children_4 = [getMaterialIcon("cancel")], react.createElement("span", {
                className: "panel-row__edit",
                onClick: (_arg_1) => {
                    updateEditFn(false);
                },
            }, ...children_4))];
            return react.createElement("span", {
                className: "d-flex",
            }, ...children_6);
        }
        else {
            const children_8 = [getMaterialIcon("edit")];
            return react.createElement("span", {
                className: "panel-row__edit",
                onClick: (_arg_2) => {
                    if (props.IsAdmin) {
                        updateEditFn(true);
                    }
                },
            }, ...children_8);
        }
    }), (maxBoundMonthsActionsHtml = renderActionRow((_arg_3) => {
        let a;
        startImmediate((a = saveContractValuationSetting(responseMaxBoundMonthsValue == null, "MaxBoundMonths", maxBoundMonthsState[0]), singleton.Delay(() => singleton.Bind(a, (_arg_4) => singleton.Return(void _arg_4)))));
    }, (arg_6) => {
        isEditingMaxBoundMonthsState[1](arg_6);
    }, isEditingMaxBoundMonthsState[0]), (addBoundMonthsActionsHtml = renderActionRow((_arg_5) => {
        let a_2;
        startImmediate((a_2 = saveContractValuationSetting(responseAddBoundMonthsValue == null, "AddBoundMonths", addBoundMonthsState[0]), singleton.Delay(() => singleton.Bind(a_2, (_arg_6) => singleton.Return(void _arg_6)))));
    }, (arg_8) => {
        isEditingAddBoundMonthsState[1](arg_8);
    }, isEditingAddBoundMonthsState[0]), (maxBoundMonthsLabel = ((arg_10 = props.GetTranslation("Contracts.MortgageSettings.Default"), toText(printf("%s (%s %s):"))("MaxBoundMonths")(arg_10)("36"))), (addBoundMonthsLabel = ((arg_13 = props.GetTranslation("Contracts.MortgageSettings.Default"), toText(printf("%s (%s %s):"))("AddBoundMonths")(arg_13)("0"))), (children_18 = [(children_12 = [react.createElement("span", {}, maxBoundMonthsLabel), render_2()((inputRecord = TextProps$1_GetDefault(), new TextProps$1(maxBoundMonthsState[0], inputRecord.Type, inputRecord.Classes, (e) => {
        const arg_15 = Browser_Types_Event__Event_get_Value(e);
        maxBoundMonthsState[1](arg_15);
    }, !(isEditingMaxBoundMonthsState[0]), inputRecord.LabelText, "contract-valuation-setting-max-bound-months-input", inputRecord.ValidationFn, inputRecord.DynamicWidth, inputRecord.HTMLProps, inputRecord.OnBlur, inputRecord.OnFocus, inputRecord.AutoComplete, inputRecord.Name))), maxBoundMonthsActionsHtml], react.createElement("div", {
        className: "contract-valuation-setting__panel-row",
    }, ...children_12)), (children_16 = [react.createElement("span", {}, addBoundMonthsLabel), render_2()((inputRecord_1 = TextProps$1_GetDefault(), new TextProps$1(addBoundMonthsState[0], inputRecord_1.Type, inputRecord_1.Classes, (e_1) => {
        const arg_16 = Browser_Types_Event__Event_get_Value(e_1);
        addBoundMonthsState[1](arg_16);
    }, !(isEditingAddBoundMonthsState[0]), inputRecord_1.LabelText, "contract-valuation-setting-add-bound-months-input", inputRecord_1.ValidationFn, inputRecord_1.DynamicWidth, inputRecord_1.HTMLProps, inputRecord_1.OnBlur, inputRecord_1.OnFocus, inputRecord_1.AutoComplete, inputRecord_1.Name))), addBoundMonthsActionsHtml], react.createElement("div", {
        className: "contract-valuation-setting__panel-row",
    }, ...children_16))], react.createElement("div", {
        className: "mortgage-settings__container-vertical",
    }, ...children_18))))))), void 0);
    let errorModalHtml;
    const matchValue = saveStatusState[0];
    switch (matchValue.tag) {
        case 1:
        case 2: {
            errorModalHtml = react.createElement(react.Fragment, {});
            break;
        }
        case 3: {
            errorModalHtml = renderAsModal("Error", (children_21 = [stripHtmlTags(matchValue.fields[0].split(""))], react.createElement("div", {}, ...children_21)), new MessageType(2), props.GetTranslation("Common.Ok"), (_arg_7) => {
                saveStatusState[1](new SaveStatus_2(0));
            });
            break;
        }
        default: {
            errorModalHtml = react.createElement(react.Fragment, {});
        }
    }
    const children_39 = [(children_35 = [(children_23 = [props.GetTranslation("Contracts.MortgageSettings.ContractValuationSetting")], react.createElement("h5", {
        className: "mb-0",
        ["data-translation"]: "Contracts.MortgageSettings.ContractValuationSetting",
    }, ...children_23)), (children_25 = [props.GetTranslation("Contracts.MortgageSettings.ContractValuationSettingDescription")], react.createElement("p", {
        className: "blockquote-footer",
        ["data-translation"]: "Contracts.MortgageSettings.ContractValuationSettingDescription",
    }, ...children_25)), (children_29 = [(children_27 = [props.GetTranslation("Contracts.MortgageSettings.MaxBoundMonthsInfo")], react.createElement("small", {
        className: "text-muted",
        ["data-translation"]: "Contracts.MortgageSettings.MaxBoundMonthsInfo",
    }, ...children_27))], react.createElement("p", {}, ...children_29)), (children_33 = [(children_31 = [props.GetTranslation("Contracts.MortgageSettings.AddBoundMonthsInfo")], react.createElement("small", {
        className: "text-muted",
        ["data-translation"]: "Contracts.MortgageSettings.AddBoundMonthsInfo",
    }, ...children_31))], react.createElement("p", {}, ...children_33))], react.createElement("div", {
        className: "contract-valuation-setting__headers",
    }, ...children_35)), react.createElement("div", {
        className: "contract-valuation-setting__container",
    }, editPanelHtml), errorModalHtml];
    return react.createElement("div", {
        className: "contract-valuation-setting mortgage-settings__section",
    }, ...children_39);
}, void 0, uncurry(2, void 0), void 0, "renderContractValuationSettingSection", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\MortgageSettings\\View.fs", 626);

class ContractTypeValuationSettingModalProps extends Record {
    constructor(ClientNr, ContractTypeCode, ContractValuationId, ContractTypeDisplay, ContractTypeMortgageId, ContractTypeMortgageName, ContractTypeMortgageOptions, MaxBoundMonths, AddBoundMonths, CloseModalFn, LoadContractTypeValuationSettingFn) {
        super();
        this.ClientNr = (ClientNr | 0);
        this.ContractTypeCode = ContractTypeCode;
        this.ContractValuationId = ContractValuationId;
        this.ContractTypeDisplay = ContractTypeDisplay;
        this.ContractTypeMortgageId = ContractTypeMortgageId;
        this.ContractTypeMortgageName = ContractTypeMortgageName;
        this.ContractTypeMortgageOptions = ContractTypeMortgageOptions;
        this.MaxBoundMonths = MaxBoundMonths;
        this.AddBoundMonths = AddBoundMonths;
        this.CloseModalFn = CloseModalFn;
        this.LoadContractTypeValuationSettingFn = LoadContractTypeValuationSettingFn;
    }
}

function ContractTypeValuationSettingModalProps$reflection() {
    return record_type("Containers.MortgageSettings.View.ContractTypeValuationSettingModalProps", [], ContractTypeValuationSettingModalProps, () => [["ClientNr", int32_type], ["ContractTypeCode", string_type], ["ContractValuationId", option_type(uint8_type)], ["ContractTypeDisplay", string_type], ["ContractTypeMortgageId", string_type], ["ContractTypeMortgageName", option_type(string_type)], ["ContractTypeMortgageOptions", list_type(tuple_type(string_type, string_type))], ["MaxBoundMonths", string_type], ["AddBoundMonths", string_type], ["CloseModalFn", lambda_type(unit_type, unit_type)], ["LoadContractTypeValuationSettingFn", lambda_type(unit_type, unit_type)]]);
}

const renderContractTypeValuationSettingModal = FunctionComponent_Of_Z5A158BBF((props) => {
    let inputRecord, LabelText, inputRecord_1, OptionValues_1, inputRecord_2, inputRecord_3;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const maxBoundMonthsState = react.useState(props.MaxBoundMonths);
    const addBoundMonthsState = react.useState(props.AddBoundMonths);
    const contractTypeMortgageIdState = react.useState(props.ContractTypeMortgageId);
    let contractValuationIdState;
    const arg = map_1((value) => value.toString(), props.ContractValuationId);
    contractValuationIdState = react.useState(arg);
    const errorMessageState = react.useState(void 0);
    const contractTypeMortgageIdHtml = selectOption((inputRecord = SelectOption_get_getDefault(), (LabelText = getTranslation("Contracts.MortgageSettings.MortgageTerms"), new SelectOption(new ValueProp(0, contractTypeMortgageIdState[0], (e) => {
        contractTypeMortgageIdState[1](Browser_Types_Event__Event_get_Value(e));
    }), "contract-type-valuation-setting-select-contract-type-mortgage", props.ContractTypeMortgageOptions, inputRecord.Classes, LabelText, inputRecord.Disabled, inputRecord.HTMLProps))));
    let contractValuationIdSelectHtml;
    const options = (props.ClientNr === 45337) ? ofArray([["1", "1"], ["2", "2"]]) : singleton_1(["1", "1"]);
    contractValuationIdSelectHtml = selectOption((inputRecord_1 = SelectOption_get_getDefault(), (OptionValues_1 = cons(["None", getTranslation("Common.None")], options), new SelectOption(new ValueProp(0, optToStr(contractValuationIdState[0]), (e_1) => {
        let arg_1;
        const _arg_1 = Browser_Types_Event__Event_get_Value(e_1);
        arg_1 = ((_arg_1 === "None") ? (void 0) : _arg_1);
        contractValuationIdState[1](arg_1);
    }), "contract-type-valuation-setting-select-valuation-id", OptionValues_1, inputRecord_1.Classes, "ContractValuationId", inputRecord_1.Disabled, inputRecord_1.HTMLProps))));
    const maxBoundMonthsInputHtml = render_2()((inputRecord_2 = TextProps$1_GetDefault(), new TextProps$1(maxBoundMonthsState[0], inputRecord_2.Type, inputRecord_2.Classes, (e_2) => {
        maxBoundMonthsState[1](Browser_Types_Event__Event_get_Value(e_2));
    }, inputRecord_2.Disabled, "MaxBoundMonths", "contract-type-valuation-setting-maxboundmonths", inputRecord_2.ValidationFn, inputRecord_2.DynamicWidth, inputRecord_2.HTMLProps, inputRecord_2.OnBlur, inputRecord_2.OnFocus, inputRecord_2.AutoComplete, inputRecord_2.Name)));
    const addBoundMonthsInputHtml = render_2()((inputRecord_3 = TextProps$1_GetDefault(), new TextProps$1(addBoundMonthsState[0], inputRecord_3.Type, inputRecord_3.Classes, (e_3) => {
        addBoundMonthsState[1](Browser_Types_Event__Event_get_Value(e_3));
    }, inputRecord_3.Disabled, "AddBoundMonths", "contract-type-valuation-setting-addboundmonths", inputRecord_3.ValidationFn, inputRecord_3.DynamicWidth, inputRecord_3.HTMLProps, inputRecord_3.OnBlur, inputRecord_3.OnFocus, inputRecord_3.AutoComplete, inputRecord_3.Name)));
    return render_3(true, new ModalSize(1), props.ContractTypeDisplay, react.createElement("div", {
        className: "mortgage-settings__container-vertical",
    }, contractValuationIdSelectHtml, contractTypeMortgageIdHtml, maxBoundMonthsInputHtml, addBoundMonthsInputHtml), getTranslation("Common.Cancel"), getTranslation("Common.Save"), (_arg_7) => {
        props.CloseModalFn();
    }, (_arg_2) => {
        const contractValuationId = (props.ClientNr === 45337) ? "2" : "1";
        const updateContractTypeMortgageIdAsyncOpt = (props.ContractTypeMortgageId !== (contractTypeMortgageIdState[0])) ? updateContractTypeMortgageId(props.ClientNr, props.ContractTypeCode, contractTypeMortgageIdState[0]) : (void 0);
        const updateMaxBoundMonthsAsyncOpt = (props.MaxBoundMonths !== (maxBoundMonthsState[0])) ? saveContractTypeValuationSetting(props.ClientNr, props.ContractTypeCode, contractValuationId, "MaxBoundMonths", maxBoundMonthsState[0]) : (void 0);
        const updateAddBoundMonthsAsyncOpt = (props.AddBoundMonths !== (addBoundMonthsState[0])) ? saveContractTypeValuationSetting(props.ClientNr, props.ContractTypeCode, contractValuationId, "AddBoundMonths", addBoundMonthsState[0]) : (void 0);
        const queueContractReEvaluation = queueContractReEvaluation_1(props.ClientNr, props.ContractTypeCode);
        let updateContractTypeValuationAsyncOpt;
        const matchValue_3 = contractValuationIdState[0];
        if (matchValue_3 == null) {
            const matchValue_6 = props.ContractValuationId;
            updateContractTypeValuationAsyncOpt = ((matchValue_6 == null) ? (void 0) : deleteContractValuation(props.ClientNr, props.ContractTypeCode, matchValue_6));
        }
        else {
            const matchValue_4 = parseByte(matchValue_3);
            if (matchValue_4 == null) {
                updateContractTypeValuationAsyncOpt = (void 0);
            }
            else {
                const contractValuationId_2 = matchValue_4;
                updateContractTypeValuationAsyncOpt = ((!equals(contractValuationId_2, props.ContractValuationId)) ? updateContractTypeValuation(props.ClientNr, props.ContractTypeCode, contractValuationId_2) : (void 0));
            }
        }
        const apiCallsToRun = choose((x) => x, ofArray([updateContractTypeMortgageIdAsyncOpt, updateMaxBoundMonthsAsyncOpt, updateAddBoundMonthsAsyncOpt]));
        props.CloseModalFn();
        let asyncResults;
        let a_2;
        if (updateContractTypeValuationAsyncOpt != null) {
            const a = updateContractTypeValuationAsyncOpt;
            a_2 = singleton.Bind(a, (_arg_3) => parallel(cons(queueContractReEvaluation, apiCallsToRun)));
        }
        else {
            a_2 = parallel(apiCallsToRun);
        }
        asyncResults = singleton.Delay(() => singleton.Bind(a_2, (_arg_5) => {
            let output_1;
            return singleton.Return(foldBack((m, m$0027) => Result_Bind((x_3) => Result_Bind((xs) => {
                let output;
                return (output = (new FSharpResult$2()), new FSharpResult$2(0, cons(x_3, xs)));
            }, m$0027), m), ofArray(_arg_5), (output_1 = (new FSharpResult$2()), new FSharpResult$2(0, empty()))));
        }));
        startImmediate(singleton.Delay(() => singleton.Bind(asyncResults, (_arg_6) => {
            const result = _arg_6;
            return singleton.Combine((result.tag === 1) ? ((errorMessageState[1](result.fields[0]), singleton.Zero())) : ((singleton.Zero())), singleton.Delay(() => {
                props.LoadContractTypeValuationSettingFn();
                return singleton.Zero();
            }));
        })));
    });
}, "ContractTypeValuationSettingModal", uncurry(2, void 0), void 0, "renderContractTypeValuationSettingModal", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\MortgageSettings\\View.fs", 827);

class ReEvaluateContractsModalProps extends Record {
    constructor(ClientNr, ContractTypeCode, CloseModalFn) {
        super();
        this.ClientNr = (ClientNr | 0);
        this.ContractTypeCode = ContractTypeCode;
        this.CloseModalFn = CloseModalFn;
    }
}

function ReEvaluateContractsModalProps$reflection() {
    return record_type("Containers.MortgageSettings.View.ReEvaluateContractsModalProps", [], ReEvaluateContractsModalProps, () => [["ClientNr", int32_type], ["ContractTypeCode", string_type], ["CloseModalFn", lambda_type(unit_type, unit_type)]]);
}

const renderQueueContractReEvaluationModal = FunctionComponent_Of_Z5A158BBF((props) => {
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const loadState = react.useState(new LoadState$2(0));
    let bodyHtml;
    const children_10 = toList(delay(() => {
        let props_9, children_8, children_4, children;
        const matchValue = loadState[0];
        switch (matchValue.tag) {
            case 1: {
                return singleton_2(dotsLoading);
            }
            case 3: {
                return singleton_2(error(matchValue.fields[0].split("")));
            }
            case 2: {
                let text;
                const arg_3 = getTranslation("Contracts.MortgageSettings.ContractsQueued");
                text = toText(printf("%i %s."))(matchValue.fields[0])(arg_3);
                return singleton_2((props_9 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "justify-content-center"])))], (children_8 = [(children_4 = [getMaterialIcon("check")], react.createElement("div", {}, ...children_4)), react.createElement("div", {
                    className: "ml-2",
                }, text)], react.createElement("p", keyValueList(props_9, 1), ...children_8))));
            }
            default: {
                return append(singleton_2((children = [getTranslation("Contracts.MortgageSettings.AreYouSure")], react.createElement("p", {}, ...children))), delay(() => {
                    let children_2, arg;
                    return singleton_2((children_2 = [(arg = getTranslation("Contracts.MortgageSettings.ContractType"), toText(printf("%s: %s"))(arg)(props.ContractTypeCode))], react.createElement("h4", {
                        className: "font-weight-bold",
                    }, ...children_2)));
                }));
            }
        }
    }));
    bodyHtml = react.createElement("div", {
        className: "text-center",
    }, ...children_10);
    const modalHeaderHtml = getModalHeader(getTranslation("Contracts.MortgageSettings.ReEvaluateContracts"), (_arg_1) => {
        props.CloseModalFn();
    });
    const modalBodyHtml = getModalBodyContainer(bodyHtml);
    let modalFooterHtml;
    const cancelButtonHtml = ((loadState[0]).tag === 0) ? modalCancel(new ButtonProps(getTranslation("Common.Cancel"), defaultProps.Content, (_arg_2) => {
        props.CloseModalFn();
    }, defaultProps.Disabled, defaultProps.Id, defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon)) : react.createElement(react.Fragment, {});
    const mainButtonHtml = ((loadState[0]).tag === 0) ? modalMain(new ButtonProps(getTranslation("Common.Run"), defaultProps.Content, (_arg_3) => {
        startImmediate((loadState[1](new LoadState$2(1)), singleton.Delay(() => singleton.Bind(queueContractReEvaluation_1(props.ClientNr, props.ContractTypeCode), (_arg) => {
            const result = _arg;
            return (result.tag === 1) ? singleton.Return(loadState[1](new LoadState$2(3, result.fields[0]))) : singleton.Return(loadState[1](new LoadState$2(2, result.fields[0])));
        }))));
    }, defaultProps.Disabled, defaultProps.Id, defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon)) : modalMain(new ButtonProps(getTranslation("Common.Close"), defaultProps.Content, (_arg_4) => {
        props.CloseModalFn();
    }, defaultProps.Disabled, defaultProps.Id, defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon));
    modalFooterHtml = getModalFooterContainer(react.createElement(react.Fragment, {}, cancelButtonHtml, mainButtonHtml));
    return modal(true, getModalContainer(new ModalSize(1), react.createElement("div", {}, modalHeaderHtml, modalBodyHtml, modalFooterHtml)));
}, "QueueContractReEvaluationModal", uncurry(2, void 0), void 0, "renderQueueContractReEvaluationModal", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\MortgageSettings\\View.fs", 920);

class ValidateContractProps extends Record {
    constructor(ClientNr, ContractTypeCode, ContractTypeCodes, CloseModalFn) {
        super();
        this.ClientNr = (ClientNr | 0);
        this.ContractTypeCode = ContractTypeCode;
        this.ContractTypeCodes = ContractTypeCodes;
        this.CloseModalFn = CloseModalFn;
    }
}

function ValidateContractProps$reflection() {
    return record_type("Containers.MortgageSettings.View.ValidateContractProps", [], ValidateContractProps, () => [["ClientNr", int32_type], ["ContractTypeCode", option_type(string_type)], ["ContractTypeCodes", list_type(tuple_type(string_type, string_type))], ["CloseModalFn", lambda_type(unit_type, unit_type)]]);
}

class ContractKind extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["NotValid", "AllContracts"];
    }
}

function ContractKind$reflection() {
    return union_type("Containers.MortgageSettings.View.ContractKind", [], ContractKind, () => [[], []]);
}

function ContractKind_ToString_5723A2D(ck) {
    if (ck.tag === 1) {
        return "AllContracts";
    }
    else {
        return "NotValid";
    }
}

function ContractKind_OfString_Z721C83C5(str) {
    switch (str) {
        case ContractKind_ToString_5723A2D(new ContractKind(0)): {
            return new ContractKind(0);
        }
        case ContractKind_ToString_5723A2D(new ContractKind(1)): {
            return new ContractKind(1);
        }
        default: {
            return toFail(printf("[ContractKind - OfString] Cannot parse \u0027%s\u0027."))(str);
        }
    }
}

const renderValidateContractModal = FunctionComponent_Of_Z5A158BBF((props) => {
    let inputRecord, LabelText, children, inputRecord_1, inputRecord_2, inputRecord_3, inputRecord_4, inputRecord_5, children_6, children_2, inputRecord_6, DisplayString, children_4, inputRecord_7, DisplayString_1;
    const allContractTypesStr = "--- All ContractTypes ---";
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const selectedContractTypeCodeState = react.useState(optToStr(props.ContractTypeCode));
    const validateContractSaveState = react.useState(new SaveStatus_2(0));
    const creditCheckState = react.useState(false);
    const payedInvoicesState = react.useState(false);
    const physicalContractApprovalState = react.useState(false);
    const monthlyValueInRangeState = react.useState(false);
    const ageInRangeState = react.useState(false);
    const contractKindChoiceState = react.useState(new ContractKind(0));
    let bodyHtml;
    const children_8 = [selectOption((inputRecord = SelectOption_get_getDefault(), (LabelText = getTranslation("Contracts.MortgageSettings.ContractType"), new SelectOption(new ValueProp(0, selectedContractTypeCodeState[0], (e) => {
        const arg_2 = Browser_Types_Event__Event_get_Value(e);
        selectedContractTypeCodeState[1](arg_2);
    }), "validate-contract-contract-type-code", cons([allContractTypesStr, allContractTypesStr], props.ContractTypeCodes), inputRecord.Classes, LabelText, inputRecord.Disabled, inputRecord.HTMLProps)))), (children = [inputCheckbox((inputRecord_1 = CheckboxInput_get_getDefault(), new CheckboxInput(inputRecord_1.Disabled, "CreditCheck", (e_1) => {
        creditCheckState[1](Browser_Types_Event__Event_get_Checked(e_1));
    }, creditCheckState[0], "validate-contract-credit-check", inputRecord_1.HTMLProps))), inputCheckbox((inputRecord_2 = CheckboxInput_get_getDefault(), new CheckboxInput(inputRecord_2.Disabled, "PayedInvoices", (e_2) => {
        payedInvoicesState[1](Browser_Types_Event__Event_get_Checked(e_2));
    }, payedInvoicesState[0], "validate-contract-payed-invoices", inputRecord_2.HTMLProps))), inputCheckbox((inputRecord_3 = CheckboxInput_get_getDefault(), new CheckboxInput(inputRecord_3.Disabled, "PhysicalContractApproval", (e_3) => {
        physicalContractApprovalState[1](Browser_Types_Event__Event_get_Checked(e_3));
    }, physicalContractApprovalState[0], "validate-contract-physical-contract-approval", inputRecord_3.HTMLProps))), inputCheckbox((inputRecord_4 = CheckboxInput_get_getDefault(), new CheckboxInput(inputRecord_4.Disabled, "MonthlyValueInRange", (e_4) => {
        monthlyValueInRangeState[1](Browser_Types_Event__Event_get_Checked(e_4));
    }, monthlyValueInRangeState[0], "validate-contract-monthly-value-in-range", inputRecord_4.HTMLProps))), inputCheckbox((inputRecord_5 = CheckboxInput_get_getDefault(), new CheckboxInput(inputRecord_5.Disabled, "AgeInRange", (e_5) => {
        ageInRangeState[1](Browser_Types_Event__Event_get_Checked(e_5));
    }, ageInRangeState[0], "validate-contract-age-on-range", inputRecord_5.HTMLProps)))], react.createElement("div", {}, ...children)), (children_6 = [(children_2 = [inputRadio((inputRecord_6 = RadioInput_get_getDefault(), (DisplayString = getTranslation("Contracts.MortgageSettings.ValidateContract.NonApproved"), new RadioInput("validate-contract-non-approved", "all-contracts-radio", (e_6) => {
        const arg_4 = ContractKind_OfString_Z721C83C5(Browser_Types_Event__Event_get_Value(e_6));
        contractKindChoiceState[1](arg_4);
    }, ContractKind_ToString_5723A2D(new ContractKind(0)), DisplayString, equals(contractKindChoiceState[0], new ContractKind(0)), inputRecord_6.Disabled))))], react.createElement("div", {}, ...children_2)), (children_4 = [inputRadio((inputRecord_7 = RadioInput_get_getDefault(), (DisplayString_1 = getTranslation("Contracts.MortgageSettings.ValidateContract.AllContracts"), new RadioInput("validate-contract-all-contracts", "all-contracts-radio", (e_7) => {
        const arg_7 = ContractKind_OfString_Z721C83C5(Browser_Types_Event__Event_get_Value(e_7));
        contractKindChoiceState[1](arg_7);
    }, ContractKind_ToString_5723A2D(new ContractKind(1)), DisplayString_1, equals(contractKindChoiceState[0], new ContractKind(1)), inputRecord_7.Disabled))))], react.createElement("div", {}, ...children_4))], react.createElement("div", {
        className: "mortgage-settings__container-horizontal",
    }, ...children_6)), info(getTranslation("Contracts.MortgageSettings.ValidateContract.TimeUntilValidated").split(""))];
    bodyHtml = react.createElement("div", {
        className: "mortgage-settings__container-vertical",
    }, ...children_8);
    const cancelButtonProps = new ButtonProps(getTranslation("Common.Cancel"), defaultProps.Content, (_arg_2) => {
        props.CloseModalFn();
    }, defaultProps.Disabled, defaultProps.Id, defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon);
    const acceptButtonProps = new ButtonProps(getTranslation("Common.Confirm"), defaultProps.Content, (_arg_3) => {
        const dto = new ValidateContractsDTO((selectedContractTypeCodeState[0]) === allContractTypesStr, selectedContractTypeCodeState[0], creditCheckState[0], payedInvoicesState[0], physicalContractApprovalState[0], monthlyValueInRangeState[0], ageInRangeState[0], ContractKind_ToString_5723A2D(contractKindChoiceState[0]));
        validateContractSaveState[1](new SaveStatus_2(1));
        startImmediate(singleton.Delay(() => singleton.Bind(saveValidateContracts(props.ClientNr, dto), (_arg_1) => {
            const result = _arg_1;
            const arg = (result.tag === 0) ? (new SaveStatus_2(2)) : (new SaveStatus_2(3, result.fields[0]));
            validateContractSaveState[1](arg);
            return singleton.Zero();
        })));
    }, defaultProps.Disabled, defaultProps.Id, defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon);
    return renderAsModalThenSaveState(true, new ModalSize(1), getTranslation("Contracts.MortgageSettings.ValidateContract"), bodyHtml, cancelButtonProps, acceptButtonProps, getTranslation("Common.Close"), (_arg_4) => {
        props.CloseModalFn();
    }, singleton_1([getTranslation("Common.Saving"), validateContractSaveState[0]]));
}, void 0, uncurry(2, void 0), void 0, "renderValidateContractModal", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\MortgageSettings\\View.fs", 1082);

class ContractTypeValuationSettingTableProps extends Record {
    constructor(ClientNr, Response, OpenModalFn, LoadContractTypeValuationSettingsFn, IsAdmin) {
        super();
        this.ClientNr = (ClientNr | 0);
        this.Response = Response;
        this.OpenModalFn = OpenModalFn;
        this.LoadContractTypeValuationSettingsFn = LoadContractTypeValuationSettingsFn;
        this.IsAdmin = IsAdmin;
    }
}

function ContractTypeValuationSettingTableProps$reflection() {
    return record_type("Containers.MortgageSettings.View.ContractTypeValuationSettingTableProps", [], ContractTypeValuationSettingTableProps, () => [["ClientNr", int32_type], ["Response", list_type(ContractTypeValuationSettingResponse$reflection())], ["OpenModalFn", lambda_type(string_type, unit_type)], ["LoadContractTypeValuationSettingsFn", lambda_type(unit_type, unit_type)], ["IsAdmin", bool_type]]);
}

const renderContractTypeValuationSettingTable = FunctionComponent_Of_Z5A158BBF((props) => {
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const reduxDispatch = useDispatch();
    const contractReEvaluationModalState = react.useState(void 0);
    const deleteContractValuationModalState = react.useState(void 0);
    const deleteContractValuationSaveState = react.useState(new SaveStatus_2(0));
    const errorMessageState = react.useState(void 0);
    const validateContractModalState = react.useState([false, void 0]);
    let contractReEvaluationModalHtml;
    const matchValue = contractReEvaluationModalState[0];
    contractReEvaluationModalHtml = ((matchValue != null) ? renderQueueContractReEvaluationModal(matchValue) : react.createElement(react.Fragment, {}));
    const dotMenu = props.IsAdmin ? ofArray([[getTranslation("Common.Edit"), props.OpenModalFn], [getTranslation("Contracts.MortgageSettings.ReEvaluateContracts"), (rowId) => {
        const matchValue_1 = tryFind((c) => (c.Index === rowId), props.Response);
        if (matchValue_1 != null) {
            const props_2 = new ReEvaluateContractsModalProps(props.ClientNr, matchValue_1.ContractTypeCode, () => {
                contractReEvaluationModalState[1](void 0);
            });
            contractReEvaluationModalState[1](props_2);
        }
    }], [getTranslation("Contracts.MortgageSettings.ValidateContract"), (rowId_1) => {
        const matchValue_2 = tryFind((c_1) => (c_1.Index === rowId_1), props.Response);
        if (matchValue_2 != null) {
            const arg = [true, matchValue_2.ContractTypeCode];
            validateContractModalState[1](arg);
        }
        else {
            reduxDispatch(warning("Could not find ContractTypeValuationSetting"));
        }
    }]]) : empty();
    const rows = map((setting_2) => {
        let children_9;
        let contractTypeMortgageIdNameHtml;
        const contractTypeName = defaultArg(setting_2.ContractTypeMortgageName, "-");
        const props_3 = [new HTMLAttr(158, defaultArg(map_1(int16ToString, setting_2.ContractTypeMortgageId), ""))];
        contractTypeMortgageIdNameHtml = react.createElement("span", keyValueList(props_3, 1), contractTypeName);
        let contractValuationDescriptionHtml;
        const contractValuationDescription = defaultArg(setting_2.ContractValuationDescription, "-");
        contractValuationDescriptionHtml = react.createElement("span", {}, contractValuationDescription);
        const statusBallHtml = renderStatusBallHtml(getTranslation, setting_2.Active);
        return [ofArray([(children_9 = [react.createElement("div", {
            className: "mr-2",
        }, statusBallHtml), react.createElement("span", {}, setting_2.Display)], react.createElement("div", {
            className: "d-flex align-items-center",
        }, ...children_9)), react.createElement("span", {}, setting_2.ContractTypeCode), contractValuationDescriptionHtml, contractTypeMortgageIdNameHtml, react.createElement("span", {}, setting_2.MaxBoundMonths), react.createElement("span", {}, setting_2.AddBoundMonths)]), setting_2.Index];
    }, sortBy((p) => [!p.Active, p.Display.trimStart()], props.Response, {
        Compare: compareArrays,
    }));
    let contractTypeValuationSettingsTable;
    const emptyMessageHtml = isEmpty(rows) ? react.createElement("div", {
        className: "mortgage-settings__table-no-values",
    }, "Missing contract types.") : react.createElement(react.Fragment, {});
    const children_20 = [renderDotMenuAreaTable(ofArray([getTranslation("Contracts.MortgageSettings.ContractType"), getTranslation("Common.Code"), getTranslation("Contracts.MortgageSettings.ContractValuationId"), getTranslation("Contracts.MortgageSettings.MortgageTerms"), "MaxBoundMonths", "AddBoundMonths"]), rows, (_arg) => dotMenu, void 0, void 0, (value_4) => {
    }), emptyMessageHtml];
    contractTypeValuationSettingsTable = react.createElement(react.Fragment, {}, ...children_20);
    let validateContractModalHtml;
    const matchValue_3 = validateContractModalState[0];
    validateContractModalHtml = (matchValue_3[0] ? renderValidateContractModal(new ValidateContractProps(props.ClientNr, matchValue_3[1], List_distinct(map((res) => [res.ContractTypeCode, res.Display], props.Response), {
        Equals: equalArrays,
        GetHashCode: arrayHash,
    }), () => {
        validateContractModalState[1]([false, void 0]);
    })) : react.createElement(react.Fragment, {}));
    let errorMessageHtml;
    const matchValue_4 = errorMessageState[0];
    if (matchValue_4 != null) {
        const errorMsg = matchValue_4;
        errorMessageHtml = error(errorMsg.split(""));
    }
    else {
        errorMessageHtml = react.createElement(react.Fragment, {});
    }
    return react.createElement(react.Fragment, {}, errorMessageHtml, contractTypeValuationSettingsTable, contractReEvaluationModalHtml, validateContractModalHtml);
}, void 0, uncurry(2, void 0), void 0, "renderContractTypeValuationSettingTable", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\MortgageSettings\\View.fs", 1223);

class ContractTypeValuationSettingProps extends Record {
    constructor(GetTranslation, IsAdmin, ClientNr, LoadContractTypeValuationSettingsFn, ContractTypeMortgageOptions, ContractTypeValuationSettingResponse) {
        super();
        this.GetTranslation = GetTranslation;
        this.IsAdmin = IsAdmin;
        this.ClientNr = (ClientNr | 0);
        this.LoadContractTypeValuationSettingsFn = LoadContractTypeValuationSettingsFn;
        this.ContractTypeMortgageOptions = ContractTypeMortgageOptions;
        this.ContractTypeValuationSettingResponse = ContractTypeValuationSettingResponse;
    }
}

function ContractTypeValuationSettingProps$reflection() {
    return record_type("Containers.MortgageSettings.View.ContractTypeValuationSettingProps", [], ContractTypeValuationSettingProps, () => [["GetTranslation", lambda_type(string_type, string_type)], ["IsAdmin", bool_type], ["ClientNr", int32_type], ["LoadContractTypeValuationSettingsFn", lambda_type(unit_type, unit_type)], ["ContractTypeMortgageOptions", list_type(tuple_type(string_type, string_type))], ["ContractTypeValuationSettingResponse", list_type(ContractTypeValuationSettingResponse$reflection())]]);
}

const renderContractTypeValuationSettingSection = FunctionComponent_Of_Z5A158BBF((props) => {
    let matchValue_2, children_8, children_4, children_6;
    const modalOpenState = react.useState(void 0);
    let tableSectionHtml;
    let modalHtml;
    const matchValue = modalOpenState[0];
    if (matchValue != null) {
        const rowId = matchValue;
        const matchValue_1 = tryFind((c) => (c.Index === rowId), props.ContractTypeValuationSettingResponse);
        if (matchValue_1 != null) {
            const setting = matchValue_1;
            modalHtml = renderContractTypeValuationSettingModal(new ContractTypeValuationSettingModalProps(props.ClientNr, setting.ContractTypeCode, setting.ContractValuationId, setting.Display, (matchValue_2 = setting.ContractTypeMortgageId, (matchValue_2 == null) ? "null" : int16ToString(matchValue_2)), setting.ContractTypeMortgageName, props.ContractTypeMortgageOptions, setting.MaxBoundMonths, setting.AddBoundMonths, () => {
                modalOpenState[1](void 0);
            }, props.LoadContractTypeValuationSettingsFn));
        }
        else {
            modalHtml = react.createElement(react.Fragment, {});
        }
    }
    else {
        modalHtml = react.createElement(react.Fragment, {});
    }
    const tableHtml = renderContractTypeValuationSettingTable(new ContractTypeValuationSettingTableProps(props.ClientNr, props.ContractTypeValuationSettingResponse, (arg_2) => {
        modalOpenState[1](arg_2);
    }, props.LoadContractTypeValuationSettingsFn, props.IsAdmin));
    tableSectionHtml = react.createElement("div", {
        className: "contract-type-valuation-setting__container",
    }, tableHtml, modalHtml);
    const children_12 = [(children_8 = [(children_4 = [props.GetTranslation("Contracts.MortgageSettings.ContractTypeValuationSetting")], react.createElement("h5", {
        className: "mb-0",
        ["data-translation"]: "Contracts.MortgageSettings.ContractTypeValuationSetting",
    }, ...children_4)), (children_6 = [props.GetTranslation("Contracts.MortgageSettings.ContractTypeValuationSettingDescription")], react.createElement("p", {
        className: "blockquote-footer",
        ["data-translation"]: "Contracts.MortgageSettings.ContractTypeValuationSettingDescription",
    }, ...children_6))], react.createElement("div", {}, ...children_8)), react.createElement("div", {
        className: "mortgage-settings__container-horizontal",
    }, tableSectionHtml)];
    return react.createElement("div", {
        className: "contract-type-valuation-setting mortgage-settings__section",
    }, ...children_12);
}, void 0, uncurry(2, void 0), void 0, "renderContractTypeValuationSettingSection", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\MortgageSettings\\View.fs", 1292);

export class MortgageSettingsProps extends Record {
    constructor(GlobalDependencies) {
        super();
        this.GlobalDependencies = GlobalDependencies;
    }
}

export function MortgageSettingsProps$reflection() {
    return record_type("Containers.MortgageSettings.View.MortgageSettingsProps", [], MortgageSettingsProps, () => [["GlobalDependencies", GlobalDependencies$reflection()]]);
}

export const view = FunctionComponent_Of_Z5A158BBF((props) => {
    let arg_10, children_2;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const contractTypeMortgagesState = react.useState(new LoadState$2(0));
    const contractValuationSettingResponseState = react.useState(new LoadState$2(0));
    const contractTypeValuationSettingResponseState = react.useState(new LoadState$2(0));
    const loadContractTypeMortgage = () => {
        contractTypeMortgagesState[1](new LoadState$2(1));
        startImmediate(singleton.Delay(() => singleton.Bind(loadContractTypeMortgage_1(props.GlobalDependencies.ClientNr), (_arg) => {
            const result = _arg;
            const arg = (result.tag === 1) ? (new LoadState$2(3, result.fields[0])) : (new LoadState$2(2, result.fields[0]));
            contractTypeMortgagesState[1](arg);
            return singleton.Zero();
        })));
    };
    const loadContractValuationSetting = () => {
        contractValuationSettingResponseState[1](new LoadState$2(1));
        startImmediate(singleton.Delay(() => singleton.Bind(loadContractValuationSetting_1(props.GlobalDependencies.ClientNr), (_arg_1) => {
            const result_1 = _arg_1;
            let arg_3;
            if (result_1.tag === 1) {
                arg_3 = (new LoadState$2(3, result_1.fields[0]));
            }
            else {
                const response = result_1.fields[0];
                arg_3 = (new LoadState$2(2, new ContractValuationSettingResponse(mapIndexed((index, setting) => (new ContractValuationSetting(setting.ContractValuationId, setting.Key, setting.Value, int32ToString(index))), response.ContractValuationSettings), response.ContractValuationIds)));
            }
            contractValuationSettingResponseState[1](arg_3);
            return singleton.Zero();
        })));
    };
    const loadContractTypeValuationSetting = () => {
        contractTypeValuationSettingResponseState[1](new LoadState$2(1));
        startImmediate(singleton.Delay(() => singleton.Bind(loadContractTypeValuationSetting_1(props.GlobalDependencies.ClientNr), (_arg_2) => {
            const result_2 = _arg_2;
            const arg_6 = (result_2.tag === 1) ? (new LoadState$2(3, result_2.fields[0])) : (new LoadState$2(2, mapIndexed((index_1, setting_1) => (new ContractTypeValuationSettingResponse(setting_1.Display, setting_1.ContractTypeCode, setting_1.ContractTypeMortgageId, setting_1.ContractTypeMortgageName, setting_1.ContractValuationId, setting_1.ContractValuationDescription, setting_1.MaxBoundMonths, setting_1.AddBoundMonths, setting_1.Active, int32ToString(index_1))), result_2.fields[0])));
            contractTypeValuationSettingResponseState[1](arg_6);
            return singleton.Zero();
        })));
    };
    react.useEffect(() => {
        loadContractTypeMortgage();
        loadContractValuationSetting();
        loadContractTypeValuationSetting();
    }, [props.GlobalDependencies]);
    let selectableContractTypeMortgage;
    let selectables;
    const matchValue = contractTypeMortgagesState[0];
    selectables = ((matchValue.tag === 2) ? map((c) => [int32ToString(c.ContractTypeMortgageId), toText(printf("(%i) %s"))(c.ContractTypeMortgageId)(c.Name)], matchValue.fields[0]) : empty());
    selectableContractTypeMortgage = ofArrayWithTail([["", getTranslation("Common.Choose")], ["null", (arg_10 = getTranslation("Contracts.MortgageSettings.TurnOffMortgage"), toText(printf("(-) %s"))(arg_10))]], selectables);
    const contractTypeMortgageSectionHtml = renderContractTypeMortgageSection(new ContractTypeMortgageSectionProps(getTranslation, props.GlobalDependencies.IsAdminUser, () => loadContractTypeMortgage_1(props.GlobalDependencies.ClientNr), (contractTypeMortgageId) => {
        const a_2 = deleteContractTypeMortgage_1(props.GlobalDependencies.ClientNr, contractTypeMortgageId);
        return singleton.Delay(() => singleton.Bind(a_2, (_arg_4) => singleton.Return((loadContractTypeMortgage(), _arg_4))));
    }, (contractTypeMortgage, isNew) => {
        const a = saveContractTypeMortgage_1(props.GlobalDependencies.ClientNr, contractTypeMortgage, isNew);
        return singleton.Delay(() => singleton.Bind(a, (_arg_3) => singleton.Return((loadContractTypeMortgage(), _arg_3))));
    }));
    let contractValuationSettingSectionHtml;
    const matchValue_1 = contractValuationSettingResponseState[0];
    switch (matchValue_1.tag) {
        case 1: {
            contractValuationSettingSectionHtml = dotsLoading;
            break;
        }
        case 3: {
            contractValuationSettingSectionHtml = error(matchValue_1.fields[0].split(""));
            break;
        }
        case 2: {
            const contractValuationId = (props.GlobalDependencies.ClientNr === 45337) ? "2" : "1";
            contractValuationSettingSectionHtml = renderContractValuationSettingSection(new ContractValuationSettingSectionProps(getTranslation, props.GlobalDependencies.IsAdminUser, matchValue_1.fields[0], (isCreateNew, key_1, value) => {
                const a_4 = saveContractValuationSetting_1(props.GlobalDependencies.ClientNr, contractValuationId, isCreateNew, key_1, value);
                return singleton.Delay(() => singleton.Bind(a_4, (_arg_5) => singleton.Return((loadContractValuationSetting(), _arg_5))));
            }));
            break;
        }
        default: {
            contractValuationSettingSectionHtml = react.createElement(react.Fragment, {});
        }
    }
    let contractTypeValuationSettingSectionHtml;
    const matchValue_2 = contractTypeValuationSettingResponseState[0];
    switch (matchValue_2.tag) {
        case 1: {
            contractTypeValuationSettingSectionHtml = dotsLoading;
            break;
        }
        case 3: {
            contractTypeValuationSettingSectionHtml = error(matchValue_2.fields[0].split(""));
            break;
        }
        case 2: {
            contractTypeValuationSettingSectionHtml = renderContractTypeValuationSettingSection(new ContractTypeValuationSettingProps(getTranslation, props.GlobalDependencies.IsAdminUser, props.GlobalDependencies.ClientNr, loadContractTypeValuationSetting, selectableContractTypeMortgage, matchValue_2.fields[0]));
            break;
        }
        default: {
            contractTypeValuationSettingSectionHtml = react.createElement(react.Fragment, {});
        }
    }
    const children_4 = [(children_2 = [getTranslation("Contracts.MortgageSettings")], react.createElement("h2", {}, ...children_2)), contractTypeMortgageSectionHtml, contractValuationSettingSectionHtml, contractTypeValuationSettingSectionHtml];
    return react.createElement("div", {
        className: "mortgage-settings",
        ["data-translation"]: "Contracts.MortgageSettings",
    }, ...children_4);
}, void 0, uncurry(2, void 0), void 0, "view", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\MortgageSettings\\View.fs", 1465);

